import React from "react";
// Route Specific
import { Routes, Route } from "react-router-dom";
import ScrollTopBehaviour from "../components/ScrollTopBehaviour";

// All HOME PAGE ROUTES
import EventOrganizer from "../views/all-home-pages/EventOrganizer";
import DocLanding from "../views/all-home-pages/DocLanding";
import DocSignatureLanding from "../views/all-home-pages/DocSignatureLanding";
import ProjectManagement from "../views/all-home-pages/ProjectManagement";
import CustomerSupport from "../views/all-home-pages/CustomerSupport";
import ProductLanding from "../views/all-home-pages/ProductLanding";
import ProductLandingDark from "../views/all-home-pages/ProductLandingDark";
import NoteTakingLanding from "../views/all-home-pages/NoteTakingLanding";
import VideoEditorLanding from "../views/all-home-pages/VideoEditorLanding";
import AppointmentScheduling from "../views/all-home-pages/AppointmentScheduling";
import MobileAppLanding from "../views/all-home-pages/MobileAppLanding";
import WebsiteBuilderLanding from "../views/all-home-pages/WebsiteBuilderLanding";
import Ecommerce from "../views/all-home-pages/Ecommerce";
import ComingSoon from "../views/all-home-pages/ComingSoon";

// All INNER PAGES ROUTES START FROM BELLOW

// PAGES DROPDOWN ALL ROUTES
// Team inner pages
import Team1 from "../views/inner-pages/pages/team/Team1";
import Team2 from "../views/inner-pages/pages/team/Team2";
import Team3 from "../views/inner-pages/pages/team/Team3";
import Team4 from "../views/inner-pages/pages/team/Team4";
import Team5 from "../views/inner-pages/pages/team/Team5";
import Team6 from "../views/inner-pages/pages/team/Team6";
import TeamDetailsV1 from "../views/inner-pages/pages/team/TeamDetailsV1";
import TeamDetailsV2 from "../views/inner-pages/pages/team/TeamDetailsV2";
import Faq from "../views/inner-pages/pages/Faq";
import FaqDetails from "../views/inner-pages/pages/FaqDetails";

// Contact us inner pages
import ContactCustomerSupport from "../views/inner-pages/pages/contact/ContactCustomerSupport";
import ContactEventOrganizer from "../views/inner-pages/pages/contact/ContactEventOrganizer";
import ContactProjectManagement from "../views/inner-pages/pages/contact/ContactProjectManagement";
import ContactDocumentation from "../views/inner-pages/pages/contact/ContactDocumentation";

// About us inner pages
import AboutCustomerSupport from "../views/inner-pages/pages/about/AboutCustomerSupport";
import AboutEventOrganizer from "../views/inner-pages/pages/about/AboutEventOrganizer";
import AboutProjectManagement from "../views/inner-pages/pages/about/AboutProjectManagement";
import AboutDocumentation from "../views/inner-pages/pages/about/AboutDocumentation";

// Pricing inner pages
import PricingCustomerSupport from "../views/inner-pages/pages/pricing/PricingCustomerSupport";
import PricingEventOrganizer from "../views/inner-pages/pages/pricing/PricingEventOrganizer";
import PricingProjectManagement from "../views/inner-pages/pages/pricing/PricingProjectManagement";

// FEATURES DROPDOWN ALL ROUTES
import Login from "../views/inner-pages/features/miscellaneous/Login";
import SignUp from "../views/inner-pages/features/miscellaneous/SignUp";
import TermsConditions from "../views/inner-pages/features/miscellaneous/TermsConditions";
import SolutionMangement from "../views/inner-pages/features/SolutionMangement";
import ProductCustomerSupport from "../views/inner-pages/features/ProductCustomerSupport";
import FeaturesCustomerSupport from "../views/inner-pages/features/FeaturesCustomerSupport";

// SERVICE PAGES ROUTES
import ServiceV1 from "../views/inner-pages/service/ServiceV1";
import ServiceV2 from "../views/inner-pages/service/ServiceV2";
import ServiceV3 from "../views/inner-pages/service/ServiceV3";
import ServiceV4 from "../views/inner-pages/service/ServiceV4";
import ServiceDetails from "../views/inner-pages/service/ServiceDetails";

// DOCS DROPDOWN ALL ROUTES
import DocFullWidth from "../views/inner-pages/docs/DocFullWidth";
import DocFullWidthBanner from "../views/inner-pages/docs/DocFullWidthBanner";
import DocBox from "../views/inner-pages/docs/DocBox";
import DocBoxWithBanner from "../views/inner-pages/docs/DocBoxWithBanner";
import Changelog from "../views/inner-pages/docs/Changelog";

// PORTFOLIO DROPDOWN ALL ROUTES
import PortfolioV1 from "../views/inner-pages/portfolio/PortfolioV1";
import PortfolioV2 from "../views/inner-pages/portfolio/PortfolioV2";
import PortfolioV3 from "../views/inner-pages/portfolio/PortfolioV3";
import PortfolioV4 from "../views/inner-pages/portfolio/PortfolioV4";
import PortfolioV5 from "../views/inner-pages/portfolio/PortfolioV5";
import PortfolioDetailsV1 from "../views/inner-pages/portfolio/PortfolioDetailsV1";

// BLOGS DROPDOWN ALL ROUTES
import BlogV1 from "../views/inner-pages/blog-pages/BlogV1";
import BlogV2 from "../views/inner-pages/blog-pages/BlogV2";
import BlogV3 from "../views/inner-pages/blog-pages/BlogV3";
import BlogV4 from "../views/inner-pages/blog-pages/BlogV4";
import CaseStudy from "../views/inner-pages/blog-pages/BlogV5.jsx";
import BlogV6 from "../views/inner-pages/blog-pages/BlogV6";
import BlogDetails from "../views/inner-pages/blog-pages/BlogDetails";

// Not Found Page
import NotFound from "../views/NotFound";

import VrLanding from "../views/all-home-pages/VrLanding";
import Cart from "../views/inner-pages/e-commerce/Cart";
import Checkout from "../views/inner-pages/e-commerce/Checkout";
import ProductDetails from "../views/inner-pages/e-commerce/ProductDetails";
import ARServices from "../views/inner-pages/service/ARServices";
import NftService from "../views/inner-pages/service/NftService";
import HeroBannerTwelve from "../components/hero-banner/HeroBannerTwelve";
import BlockchainDevelopment from "../views/inner-pages/service/BlockchainDevelopment";
import MobileGameDevelopment from "../views/inner-pages/service/MobileGameDevelopment";
import UnityGameDevelopment from "../views/inner-pages/service/UnityGameDevelopment";
import MMORPGGameDevelopment from "../views/inner-pages/service/MMORPGGameDevelopment";
import P2eGameDevelopment from "../views/inner-pages/service/P2eGameDevelopment";
import WebGameDevelopment from "../views/inner-pages/service/WebGameDevelopment";
import RaidenVerse from "../views/inner-pages/service/RaidenVerse";
import RaidenSimx from "../views/inner-pages/service/RaidenSimx";
import RaidenCogni from "../views/inner-pages/service/RaidenCongni";
import RaidenArcviz from "../views/inner-pages/service/RaidenArcviz";
import ClashofEmpire from "../views/inner-pages/service/ClashofEmpire";

import MobileAppDevelopment from "../views/inner-pages/service/MobileGameDevelopment";
import IphoneAppDevelopment from "../views/inner-pages/service/MMORPGGameDevelopment";
import AndroidAppDevelopment from "../views/inner-pages/service/AndroidAppDevelopment";
import FlutterDevelopmenet from "../views/inner-pages/service/FlutterDevelopmenet";
import ReactNativeDevelopment from "../views/inner-pages/service/ReactNativeDevelopment";
import WearableDevelopment from "../views/inner-pages/service/WearableDevelopment";
import HybridDevelopment from "../views/inner-pages/service/HybridDevelopment";
import MobileAppDevelopers from "../views/inner-pages/service/MobileAppDevelopers";
import AppMaintenenceSupport from "../views/inner-pages/service/AppMaintenenceSupport";
import WebDesign from "../views/inner-pages/service/WebDesign";
import WebDevelopment from "../views/inner-pages/service/WebDevelopment";
import PhpDevelopment from "../views/inner-pages/service/PhpDevelopment";
import JavaDevelopment from "../views/inner-pages/service/JavaDevelopment";
import AngularDevelopment from "../views/inner-pages/service/AngularDevelopment";
import RubyONRailsdevelopment from "../views/inner-pages/service/RubyONRailsdevelopment";
import EcommerceWebDevelopment from "../views/inner-pages/service/EcommerceWebDevelopment";
import SoftwareDevelopment from "../views/inner-pages/service/SoftwareDevelopment";

import BlockChainApp from "../views/inner-pages/service/BlockChainApp";
import ARVRDevelopment from "../views/inner-pages/service/ARVRDevelopment";
import AIMLDevelopment from "../views/inner-pages/service/AIMLDevelopment";
import IOTDevelopment from "../views/inner-pages/service/IOTDevelopment";
import POSSoftwareDevelopment from "../views/inner-pages/service/POSSoftwareDevelopment";
import Web3Development from "../views/inner-pages/service/Web3Development";
import AIDevelopmentCompany from "../views/inner-pages/service/AIDevelopmentCompany";

import PokerGameDevelopment from "../views/inner-pages/service/PokerGameDevelopment";
import LudoGameDev from "../views/inner-pages/service/LudoGameDev.jsx";
// import ARGameDev from "../views/inner-pages/service/ARGameDev.jsx";
import ARDevelopmentGame from "../views/inner-pages/service/ARDevelopmentGame.jsx";
import CasinoGameDev from "../views/inner-pages/service/CasinoGameDev.jsx";
import VRGameDev from "../views/inner-pages/service/VRGameDev.jsx";
import UnrealEngineGameDev from "../views/inner-pages/service/UnrealEngineGameDev.jsx";
import UnityGameDev from "../views/inner-pages/service/UnityGameDev.jsx";
import RummyGameDev from "../views/inner-pages/service/RummyGameDev.jsx";
import ArcadeGameDev from "../views/inner-pages/service/ArcadeGameDev.jsx";
import BingoGameDev from "../views/inner-pages/service/BingoGameDev.jsx";
import BlockChainGameDev from "../views/inner-pages/service/BlockChainGameDev.jsx";
import BoardGameDev from "../views/inner-pages/service/BoardGameDev.jsx";

import VirutalVegas from "../views/inner-pages/Products/VirutalVegas.jsx";
import MetaverseRoyal from "../views/inner-pages/Products/MetaverseRoyal.jsx";

import RequestQuote from "../assets/Sub-component/RequestQuote.jsx";

import Carrier from "../components/contact/Carrier.jsx";
import ContactUs from "../components/contact/ContactUs.jsx";

import PrivacyPolicy from "../views/inner-pages/PrivacyPolicy.jsx";
import TeamsAndConditions from "../views/inner-pages/TeamsAndConditions.jsx";
import TermsConditionsNew from "../views/inner-pages/terms-conditions.jsx";
 

import CaseStudyDetails from "../components/blog/CaseStudyDetails.jsx";
const AllRoutes = () => {
  return (
    <>
      <ScrollTopBehaviour />
      <Routes>
        <Route path="/eventOrganizer" element={<EventOrganizer />} />
        <Route path="/doc-landing" element={<DocLanding />} />
        <Route path="/doc-signature" element={<DocSignatureLanding />} />
        <Route path="/project-management" element={<ProjectManagement />} />
        <Route path="/" element={<CustomerSupport />} />
        <Route path="/product-landing" element={<ProductLanding />} />
        <Route path="/product-landing-dark" element={<ProductLandingDark />} />
        <Route path="/note-taking-landing" element={<NoteTakingLanding />} />
        <Route path="/video-editor-landing" element={<VideoEditorLanding />} />
        <Route
          path="/appointment-scheduling"
          element={<AppointmentScheduling />}
        />
        <Route path="/mobile-app-landing" element={<MobileAppLanding />} />
        <Route path="/website-builder" element={<WebsiteBuilderLanding />} />
        <Route path="/form-survey-landing" element={<ServiceDetails />} />
        <Route path="/vr-landing" element={<VrLanding />} />
        <Route path="/e-commerce" element={<Ecommerce />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/product-details" element={<ProductDetails />} />
        <Route path="/coming-soon" element={<ComingSoon />} />

        {/* Pages Dropdown Routes */}
        <Route path="/team-1" element={<Team1 />} />
        <Route path="/team-2" element={<Team2 />} />
        <Route path="/team-3" element={<Team3 />} />
        <Route path="/team-4" element={<Team4 />} />
        <Route path="/team-5" element={<Team5 />} />
        <Route path="/team-6" element={<Team6 />} />
        <Route path="/team-details-v1" element={<TeamDetailsV1 />} />
        <Route path="/team-details-v2" element={<TeamDetailsV2 />} />
        {/* faq inner pages */}
        <Route path="/faq" element={<Faq />} />
        <Route path="/faq-details" element={<FaqDetails />} />
        {/* contact us inner pages */}
        <Route path="/contact-cs" element={<ContactCustomerSupport />} />
        <Route path="/contact-eo" element={<ContactEventOrganizer />} />
        <Route path="/contact-pm" element={<ContactProjectManagement />} />
        <Route path="/contact-doc" element={<ContactDocumentation />} />
        {/* about us inner pages */}
        <Route path="/about-us" element={<AboutCustomerSupport />} />
        <Route path="/about-eo" element={<AboutEventOrganizer />} />
        <Route path="/about-pm" element={<AboutProjectManagement />} />
        <Route path="/about-doc" element={<AboutDocumentation />} />
        {/* pricing inner pages */}
        <Route path="/pricing-cs" element={<PricingCustomerSupport />} />
        <Route path="/pricing-eo" element={<PricingEventOrganizer />} />
        <Route path="/pricing-pm" element={<PricingProjectManagement />} />

        {/* Feature Dropdown Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/SignUp" element={<SignUp />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/solution-management" element={<SolutionMangement />} />
        <Route
          path="/product-customer-support"
          element={<ProductCustomerSupport />}
        />
        <Route
          path="/features-customer-support"
          element={<FeaturesCustomerSupport />}
        />

        {/* Service inner pages */}
        <Route
          path="/blockchain-game-development-company"
          element={<ServiceV1 />}
        />
        <Route
          path="/augmented-reality-ar-development-company"
          element={<ARServices />}
        />
        <Route
          path="/augmented-reality-ar-development"
          element={<ServiceV2 />}
        />
        <Route
          path="/augmented-reality-vr-development-company"
          element={<ServiceV3 />}
        />
        <Route path="/metaverse-development" element={<ServiceV4 />} />
        {/* <Route path="/web3-development" element={<FormSurveyLanding />} />  /noo needed */}
        <Route path="/nft-development-company" element={<NftService />} />
        <Route path="/de-fi-development" element={<VideoEditorLanding />} />
        <Route
          path="/blockchain-development"
          element={<BlockchainDevelopment />}
        />
        {/* // here is starts from fresh // */}
        <Route
          path="/mobile-app-development"
          element={<MobileAppDevelopment />}
        />
        <Route
          path="/iphone-app-development"
          element={<IphoneAppDevelopment />}
        />
        <Route
          path="/android-app-development"
          element={<AndroidAppDevelopment />}
        />
        <Route
          path="/flutter-app-development"
          element={<FlutterDevelopmenet />}
        />
        <Route
          path="/react-native-development"
          element={<ReactNativeDevelopment />}
        />
        <Route path="/wearable-development" element={<WearableDevelopment />} />
        <Route path="/hybrid-development" element={<HybridDevelopment />} />
        <Route
          path="/mobile-app-developers"
          element={<MobileAppDevelopers />}
        />
        <Route
          path="/app-maintenence-support"
          element={<AppMaintenenceSupport />}
        />

        {/* // Web Developers  inner pages */}
        <Route path="/webdesign" element={<WebDesign />} />
        <Route path="/web-development" element={<WebDevelopment />} />
        <Route path="/php-development" element={<PhpDevelopment />} />
        <Route path="/java-development" element={<JavaDevelopment />} />
        <Route path="/angular-develoment" element={<AngularDevelopment />} />
        <Route path="/ruby-on-rails" element={<RubyONRailsdevelopment />} />
        <Route
          path="/ecommerce-web-development"
          element={<EcommerceWebDevelopment />}
        />
        <Route path="/software-development" element={<SoftwareDevelopment />} />

        {/* Emerging technologies  */}
        <Route path="/blockchain-app" element={<BlockChainApp />} />
        <Route path="/ar-vr-development" element={<ARVRDevelopment />} />
        <Route path="/ai-ml-development" element={<AIMLDevelopment />} />
        <Route path="/iot-development" element={<IOTDevelopment />} />
        <Route
          path="/pos-software-development"
          element={<POSSoftwareDevelopment />}
        />
        <Route path="/web3-development" element={<Web3Development />} />
        <Route
          path="/ai-development-company"
          element={<AIDevelopmentCompany />}
        />

        {/* Mobile game development  */}
        <Route
          path="/poker-game-development"
          element={<PokerGameDevelopment />}
        />
        <Route path="/ludo-game-development" element={<LudoGameDev />} />
        <Route path="/ar-game-development" element={<ARDevelopmentGame />} />
        <Route path="/casino-game-development" element={<CasinoGameDev />} />
        <Route path="/vr-game-development" element={<VRGameDev />} />
        <Route
          path="/unreal-engine-game-development"
          element={<UnrealEngineGameDev />}
        />
        <Route path="/unity-game-development" element={<UnityGameDev />} />
        <Route path="/rummy-game-development" element={<RummyGameDev />} />
        <Route path="/arcade-game-development" element={<ArcadeGameDev />} />
        <Route path="/bingo-game-development" element={<BingoGameDev />} />
        <Route
          path="/blockchain-game-development"
          element={<BlockChainGameDev />}
        />
        <Route path="/board-game-development" element={<BoardGameDev />} />

        {/* this changes end by fresh  */}
        <Route
          path="/unity-game-development"
          element={<UnityGameDevelopment />}
        />
        <Route path="/unreal-development" element={<ProductLandingDark />} />
        <Route
          path="/mmorpg-game-development"
          element={<MMORPGGameDevelopment />}
        />
        <Route path="/p2e-game-develpment" element={<P2eGameDevelopment />} />
        <Route path="/web3-game-develpment" element={<WebGameDevelopment />} />
        <Route path="/blog" element={<BlogV1 />} />
        <Route path="/case-study" element={<CaseStudy />} />
        <Route path="/raiden-verse" element={<RaidenVerse />} />
        <Route path="/raiden-simx" element={<RaidenSimx />} />
        <Route path="/raiden-cogni" element={<RaidenCogni />} />
        <Route path="/raiden-arcviz" element={<RaidenArcviz />} />

        <Route path="/clash-empire" element={<ClashofEmpire />} />
        <Route path="/virutal-vegas" element={<VirutalVegas />} />
        <Route path="/metaverse-royal" element={<MetaverseRoyal />} />

        <Route path="/career" element={<Carrier />} />

        <Route path="/request-quote" element={<RequestQuote />} />

        <Route path="/contactus" element={<ContactUs />} />

        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        <Route path="/terms-and-conditions" element={<TermsConditionsNew />} />
        <Route path="/terms-and-condions" element={<TeamsAndConditions />} />

        <Route path="/casestudy-details/:id" element={<CaseStudyDetails/>} />

        {/* inner pages Docs   */}
        <Route path="/doc-full-width" element={<DocFullWidth />} />
        <Route path="/doc-full-width-banner" element={<DocFullWidthBanner />} />
        <Route path="/doc-box" element={<DocBox />} />
        <Route path="/doc-box-with-banner" element={<DocBoxWithBanner />} />
        <Route path="/changelog" element={<Changelog />} />

        {/* inner Portfolio pages Dropdown   */}
        <Route path="/classic-style" element={<PortfolioV1 />} />
        <Route path="/grid-two-col" element={<PortfolioV2 />} />
        <Route path="/grid-three-col" element={<PortfolioV3 />} />
        <Route path="/gallery-slider" element={<PortfolioV4 />} />
        <Route path="/grid-single" element={<PortfolioV5 />} />
        <Route path="/portfolio-details-v1" element={<PortfolioDetailsV1 />} />

        {/* inner Blog pages Dropdown   */}
        {/* <Route path="/blog-v1" element={<BlogV1 />} />
        <Route path="/blog-v2" element={<BlogV2 />} />
        <Route path="/blog-v3" element={<BlogV3 />} />
        <Route path="/blog-v4" element={<BlogV4 />} />
        <Route path="/blog-v5" element={<CaseStudy />} />
        <Route path="/blog-v6" element={<BlogV6 />} /> */}
        <Route path="/blog-details/:id" element={<BlogDetails />} />
        <Route path="*" element={<NotFound />} />

        {/* NotFound Route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default AllRoutes;
